import { HStack, Img, Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import boyImage from '../../../assets/boyImage.jpg';
import { dynamicPathhandler } from '../../../components/utils/dynamicPathHandler';

const OfferWithPrice = ({ advert }) => {
  const navigate = useNavigate();
  const { TOP_PRODUCT_SCREEN } = PROTECTED_PATHS;
  const parentPath = dynamicPathhandler(TOP_PRODUCT_SCREEN);

  return (
    <HStack
      my='4'
      bg='#fff'
      shadow='md'
      borderRadius='5px'
      pr='1.5rem'
      cursor='pointer'
      h='105px'
      onClick={() => navigate(`${parentPath}/${advert?._id}`)}
    >
      <Img
        w={['120px']}
        maxW='120px'
        h={['100px']}
        objectFit='cover'
        borderRadius='5px'
        src={advert?.imageUrl[0] || boyImage}
        alt='news-image'
      />
      <Stack spacing={'3'} color='#7A7A7A'>
        <Text fontWeight='bold'>{advert?.itemName}</Text>
        <Text m='0 !important' fontSize='12px'>
          {advert?.itemDescription}
        </Text>

        <HStack justify='space-between'>
          <Text fontWeight='bold' fontSize='14px'>
            &#8358; {advert?.price}
          </Text>
          <Text>see more</Text>
        </HStack>
      </Stack>
    </HStack>
  );
};

export default OfferWithPrice;
